export const services = [
  {
    id: "restoration",
    no: "01",
    title: "原状回復工事",
    en: "Restoration",
    desc: "退去後の修繕からクリーニングまで、次の入居者様を迎える準備を丁寧に。",
    icon: "ri-home-smile-line",
    image: "https://tsubaki-k.com/wp-content/uploads/520117962.png",
    link: "https://wind-sekoujirei1.my.canva.site/page-4/page-11",
  },
  {
    id: "interior",
    no: "02",
    title: "内装リフォーム",
    en: "Interior Reform",
    desc: "暮らしのスタイルに合わせて空間を再構築。価値を高めるリニューアル。",
    icon: "ri-paint-brush-line",
    image: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&q=60&w=800",
    link: "https://wind-sekoujirei1.my.canva.site/page-4/page-6",
  },
  {
    id: "renovation",
    no: "03",
    title: "リノベーション",
    en: "Renovation",
    desc: "間取り変更や大規模改修まで、住まいの未来をデザインします。",
    icon: "ri-building-line",
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&q=60&w=800",
    link: "https://wind-sekoujirei1.my.canva.site/page-4/page-10",
  },
  {
    id: "exterior",
    no: "04",
    title: "外壁塗装",
    en: "Exterior Painting",
    desc: "美観と耐久性を高め、建物の資産価値を長く守ります。",
    icon: "ri-brush-line",
    image: "https://image.space.rakuten.co.jp/d/strg/ctrl/9/814bcd236738531f3e5a00b5240ce3d81c34ba64.78.2.9.2.jpeg",
    link: "https://wind-sekoujirei1.my.canva.site/page-4/page-7",
  },
  {
    id: "repair",
    no: "05",
    title: "入居中修繕",
    en: "Repair",
    desc: "水回りトラブルなど、入居中の困りごとに迅速に対応します。",
    icon: "ri-tools-line",
    image: "https://nodakankouji.com/wp-content/uploads/AdobeStock_443407069.jpg",
    link: "https://wind-sekoujirei1.my.canva.site/page-4/page-8",
  },
  {
    id: "electric",
    no: "06",
    title: "電気工事",
    en: "Electric Work",
    desc: "コンセント増設や照明交換など、暮らしを支える電気のお仕事を。",
    icon: "ri-flashlight-line",
    image: "https://p-tech-denki.com/wp-content/uploads/bnr_img005.jpg",
    link: "https://wind-sekoujirei1.my.canva.site/page-4/page-12",
  },
  {
    id: "equipment",
    no: "07",
    title: "設備工事",
    en: "Equipment",
    desc: "キッチン・浴室・トイレなど、住宅設備の新設・交換に対応。",
    icon: "ri-restaurant-2-line",
    image: "https://10-1.co.jp/blog_sumainoConcierge/wp-content/uploads/2022/09/%E6%B0%B4%E5%9B%9E%E3%82%8A%E3%83%AA%E3%83%95%E3%82%A9%E3%83%BC%E3%83%A0-1.jpeg",
    link: "https://wind-sekoujirei1.my.canva.site/page-4/page-9",
  },
  {
    id: "cleaning",
    no: "08",
    title: "ハウスクリーニング",
    en: "House Cleaning",
    desc: "プロの技術と専用機材で、お住まいを徹底的にリフレッシュ。",
    icon: "ri-sparkling-2-line",
    image: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=60&w=800",
    link: "https://wind-sekoujirei1.my.canva.site/page-4/page-5",
  },
  {
    id: "aircon",
    no: "09",
    title: "エアコン洗浄",
    en: "Aircon Wash",
    desc: "カビやホコリを分解洗浄。空気がうまれかわるクリーニングを。",
    icon: "ri-windy-line",
    image: "https://www.osoujihonpo.com/assets/images/guide/body/photo-240607-06.jpg",
    link: "https://wind-sekoujirei1.my.canva.site/page-4",
  },
];